import { Permissions } from './access-control/enums/permissions';
import hasPermission from './access-control/has-permission';

export const starterPlanRestriction = () =>
  !hasPermission(Permissions.SEQUENCE_WRITE) &&
  !hasPermission(Permissions.PROSPECT_WRITE) &&
  !hasPermission(Permissions.TEMPLATE_WRITE) &&
  !hasPermission(Permissions.API_TOKEN_WRITE);
